import React, {useState} from 'react';
import moment from 'jalali-moment';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {useDispatch} from 'react-redux';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {useNavigate} from 'react-router-dom';

// import {RootState} from '../../../../store/redux';
import DotsLoading from '../../../../components/dotsLoading';
import {
  addRegisterAdvertisement,
  resetRegisterAdvertisement,
} from '../../../../store/redux/advertisementRegisteration';
import useDeleteMyAdvertisment from '../../../../services/hookService/my-account/deleteMyAdvertisment/useDeleteMyAdvertisment';
import {clearAllData} from '../../../../store/redux/addPictureAdvertisment';
import useGetMyAdverisements from '../../../../services/hookService/getMyAdvertisements/useGetAdverisements';
import NotFoundIcon from './../../../../assets/image/sponsor/404.svg';
import useGetAllNotifications from '../../../../services/hookService/getAllNotification/useGetAllNotifications';
export interface DeleteBotoomSheet {
  isOpen: boolean;
  data: null | IMyAdvertismentData;
}
const BuyList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const state = useSelector(
  //   (state: RootState) => state.advertisementRegisteration,
  // );
  const {data, isLoading, refetch} = useGetMyAdverisements({filter: 'buy'});
  const {refetch: refetchAdNotificatons} = useGetAllNotifications();
  const [deleteItem, setDeleteItem] = useState<DeleteBotoomSheet>({
    isOpen: false,
    data: null,
  });

  const {mutate} = useDeleteMyAdvertisment({
    filter: 'requirement',
    refetch: () => {
      refetch();
      refetchAdNotificatons();
      setDeleteItem({isOpen: false, data: null});
    },
  });
  const handeDeleteItem = (guid: string) => {
    mutate(guid);
  };

  return (
    <>
      {isLoading ? (
        <div className="my-auto">
          <DotsLoading />
        </div>
      ) : (
        <>
          {!data?.length ? (
            <div className="flex flex-col items-center justify-center px-3 text-sm text-gray-800 flex-1">
              <div className="flex flex-col justify-center items-center gap-6">
                <img src={NotFoundIcon} alt="not found" className="w-14" />
                <span>شما در این دسته آگهی‌ ثبت نکرده‌اید</span>
              </div>
              <button
                className="w-full text-farm-shop-500 border-[1px] border-solid !border-farm-shop-500 rounded bg-white py-3 mt-28"
                onClick={() => navigate('/advertisement-registeration')}
              >
                ثبت آگهی خرید
              </button>
            </div>
          ) : (
            data?.map((item, index) => (
              <React.Fragment key={index}>
                <div className="w-full my-2 flex-col  px-2 gap-3 bg-white items-center  flex rounded-[8px] shadow-sm relative py-2 min-h-[144px]">
                  <div className="flex bg-gray-50 text-sm rounded-[8px] w-full h-full p-2">
                    {item.title}
                  </div>
                  <div className="flex w-full justify-between items-center">
                    <div className="flex items-center text-xs text-gray-700 gap-2">
                      <div className="flex items-center gap-1">
                        <SpanIcon className="icon-nameLocation text-lg" />
                        <span>
                          {item.state?.name || ''} - {item.city?.name || ''}
                        </span>
                      </div>
                      |
                      {item.status === 'rejected' && (
                        <span className="flex items-center justify-center rounded-[8px] text-red-500 bg-red-50 p-1">
                          رد شده
                        </span>
                      )}
                      {item.status === 'pending' && (
                        <span className="flex items-center justify-center rounded-[8px] text-warning-400 bg-warning-50 p-1">
                          در انتظار تایید
                        </span>
                      )}
                      {item.status === 'published' && (
                        <span className="flex items-center justify-center rounded-[8px] text-gray-700">
                          {item.published_at &&
                            calculateDate(item.published_at)}
                        </span>
                      )}
                    </div>
                    <div className="text-sm font-Medium flex gap-2 items-center">
                      {item.status === 'published' && (
                        <span
                          className="text-farm-shop-500"
                          onClick={() => {
                            navigate(
                              `/my-ads/requirement/${item.guid}/${item.requirement_type}`,
                              {
                                state: {
                                  type: 'requirement',
                                  requirement_type: item.requirement_type,
                                },
                              },
                            );
                            dispatch(resetRegisterAdvertisement({}));
                            dispatch(clearAllData());
                          }}
                        >
                          مدیریت آگهی
                        </span>
                      )}
                      {item.status === 'rejected' && (
                        <div className="flex items-center gap-2">
                          <span
                            className="text-farm-shop-500"
                            onClick={() => {
                              navigate(
                                `/edit/advertisment/${item.guid}/${item.requirement_type}`,
                                {state: {type: 'requirement'}},
                              );
                              dispatch(resetRegisterAdvertisement({}));
                              dispatch(clearAllData());
                              dispatch(
                                addRegisterAdvertisement({
                                  ad_type: {
                                    title: 'آگهی فروشگاهی',
                                    value: 'store',
                                  },
                                }),
                              );
                            }}
                          >
                            رفع نواقص{' '}
                          </span>
                          <span
                            className="text-red-500"
                            onClick={() =>
                              setDeleteItem({isOpen: false, data: item})
                            }
                          >
                            حذف
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ))
          )}
        </>
      )}
      <BottomSheet
        onDismiss={() => {
          setDeleteItem({isOpen: false, data: null});
        }}
        open={deleteItem.isOpen}
        blocking={true}
        className="transition ease-in-out delay-250 "
      >
        <div className="w-full flex flex-col gap-2 p-3">
          <div className="flex w-full justify-between">
            <p className="text-md font-Regular">حذف آگهی</p>
            <SpanIcon
              className="icon-nameClose-remove text-xl"
              onClick={() => setDeleteItem({isOpen: false, data: null})}
            />
          </div>
          <p className="text-sm font-Regular">
            آیا اطمینان به حذف آگهی
            <span className="text-md font-DemiBold">
              {deleteItem.data?.title}
            </span>
            دارید؟
          </p>
          <div className="w-full flex justify-between gap-2 items-center text-md font-Medium">
            <button
              className="w-[70%] bg-red-500 h-[48px] text-white text-md rounded-[8px] font-Medium"
              onClick={() =>
                deleteItem.data?.guid &&
                handeDeleteItem(deleteItem.data?.guid || '')
              }
            >
              بله، حذف
            </button>
            <button
              className="w-[30%] text-farm-shop-500 h-[48px] text-md font-Medium border border-farm-shop-500 rounded-[8px]"
              onClick={() => setDeleteItem({isOpen: false, data: null})}
            >
              خیر
            </button>
          </div>
        </div>
      </BottomSheet>
    </>
  );
};

export default BuyList;
export const calculateDate = (day: string) => {
  const jalaliDate = moment(day);
  jalaliDate.locale('fa');
  return jalaliDate.format('DD MMMM YYYY ');
};
